import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BookingType, PriceInBookingType } from "@afidium/ts-facade";
import { TravellerType } from "@afidium/ts-facade/model/travellerType";

@Component({
    selector: 'tarification-details',
    template: `
        <tarifications-header [price]="price"
                              [costOrRetail]="costOrRetail"
                              [showLink]="false"
                              (onPriceSelect)="onPriceSelect.emit($event)"
                              [booking]="booking">

        </tarifications-header>
        <tarification-details-table [costOrRetail]="costOrRetail"
                                    [price]="price"
                                    [booking]="booking"
                                    [suffix]="'tarifications'">
        </tarification-details-table>
    `,
    styles: []
})
export class TarificationDetailsComponent {
    @Input()
    public price: PriceInBookingType;

    @Input()
    public travellers: TravellerType[];

    @Input()
    public booking: BookingType;

    @Input()
    public costOrRetail: string;

    @Output()
    public readonly onPriceSelect: EventEmitter<string> = new EventEmitter<string>();
}
